import { render, staticRenderFns } from "./ASnippetSelfAssessmentState.vue?vue&type=template&id=34acac02&"
import script from "./ASnippetSelfAssessmentState.vue?vue&type=script&lang=ts&"
export * from "./ASnippetSelfAssessmentState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports